export { default } from './SliceZone';
